// src/utils/tpnUtils.ts
import { TpnConfig } from '../types/tpnConfig';

/**
 * Checks if TPN configuration exists and has valid config items
 * @param tpnConfig - The TPN configuration object
 * @returns boolean indicating if TPN config is valid and has items
 */
export const hasTpnConfig = (tpnConfig: TpnConfig | null): boolean => {
  return !!(tpnConfig?.tpn_config && tpnConfig.tpn_config.length > 0);
};

/**
 * Determines if cart icon should be visible based on TPN configuration
 * @param showCartIcon - Whether cart icon is enabled in widget settings
 * @param tpnConfig - The TPN configuration object
 * @returns boolean indicating if cart icon should be shown
 */
export const shouldShowCartIcon = (
  showCartIcon: boolean,
  tpnConfig: TpnConfig | null
): boolean => {
  return !!(showCartIcon && hasTpnConfig(tpnConfig));
};

/**
 * Checks if TPN integration is active (has valid config and items)
 * @param tpnConfig - The TPN configuration object
 * @returns boolean indicating if TPN is active
 */
export const isTpnActive = (tpnConfig: TpnConfig | null): boolean => {
  return hasTpnConfig(tpnConfig);
};

/**
 * Gets the count of TPN configuration items
 * @param tpnConfig - The TPN configuration object
 * @returns number of TPN config items
 */
export const getTpnConfigCount = (tpnConfig: TpnConfig | null): number => {
  return tpnConfig?.tpn_config?.length || 0;
};
